module.exports = __webpack_public_path__ + "static/media/credit-card-blank.ec4ee151.svg";